import { Select } from '@uag/react-core';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { LengthUnit } from 'app/modules/wallforming/components/scenes/types/lengthUnit';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

import 'app/modules/wallforming/custom-styles/customSelectStyle.css';

const lengthUnitOptions: { value: LengthUnit; label: string }[] = Object.values(LengthUnit).map((unit) => ({
    value: unit,
    label: unit
}));

const lengthUnits = new Set(Object.values(LengthUnit));
const isLengthUnit = (unit: string): unit is LengthUnit => lengthUnits.has(unit as LengthUnit);

export const UnitSelector = () => {
    const { t } = useTranslation();

    const { lengthUnit, setLengthUnit } = usePlacementStore(
        useShallow((state) => ({
            lengthUnit: state.lengthUnit,
            setLengthUnit: state.setLengthUnit
        }))
    );

    const handleUnitChange = useCallback(
        (unit: string | null) => {
            if (unit && isLengthUnit(unit)) {
                setLengthUnit(unit);
            }
        },
        [setLengthUnit]
    );

    return (
        <div className="flex flex-col px-3 mt-3 pb-3" onMouseDown={(e) => e.stopPropagation()}>
            <span className="text-xs font-medium text-text-light uppercase tracking-wide mb-2">
                {t('labelLengthUnit')}
            </span>
            <Select
                className="custom-select unit-select"
                data={lengthUnitOptions}
                value={lengthUnit}
                onChange={(value) => handleUnitChange(value)}
            />
        </div>
    );
};
